module.exports = __webpack_public_path__ + "img/decheader.40355ed3.png";